import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import type { FileTypeCellModel } from '@/features/knowledge-bases/lib';

export interface FileTypeCellProps {
  model: FileTypeCellModel;
}

export function FileTypeCell({ model }: FileTypeCellProps) {
  const { t } = useTranslation('knowledge');

  if (!model.primary) {
    return (
      <span className="text-muted-foreground">
        --
        <span className="sr-only">
          {t('knowledgeBases.knowledgeBaseDocumentsTable.noTypeAssigned')}
        </span>
      </span>
    );
  }

  const { label, Icon } = model.primary;

  return (
    <div className="flex flex-wrap items-center gap-1">
      <Badge variant="secondary" roundness="full">
        <Icon />
        {label}
      </Badge>
      {model.overflowCount > 0 && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge variant="secondary" roundness="full">
                {t('knowledgeBases.knowledgeBaseDocumentsTable.additionalTagsCount', {
                  count: model.overflowCount,
                })}
              </Badge>
            </TooltipTrigger>
            <TooltipContent>{model.overflowLabels.join(', ')}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}

FileTypeCell.displayName = 'FileTypeCell';
